import {
  ROLE_ADMIN,
  ROLE_UNDERWRITER,
  ROLE_BROKER,
  ROLE_MANAGER,
  ROLE_BROKER_PARTNER,
  ROLE_ACCOUNT_MANAGER,
  ROLE_ACCOUNT_ASSISTANT,
  WORKFLOW_TYPE_ALL,
  WORKFLOW_TYPE_AUTO,
  WORKFLOW_TYPE_HOME,
  WORKFLOW_TYPE_CONDO,
  WORKFLOW_TYPE_TENANT,
  WORKFLOW_TYPE_BUSINESS,
  WORKFLOW_TYPE_LIFE,
  WORKFLOW_TYPE_TRAVEL,
  WORKFLOW_TYPE_PET,
  WORKFLOW_TYPE_OTHER,
} from 'variables/constants';

const ROLES_OPTIONS = [
  { value: `${ROLE_ADMIN}`, label: 'Admin' },
  { value: `${ROLE_UNDERWRITER}`, label: 'Underwriter' },
  { value: `${ROLE_BROKER}`, label: 'Broker' },
  { value: `${ROLE_MANAGER}`, label: 'Manager' },
  { value: `${ROLE_BROKER_PARTNER}`, label: 'Broker Partner' },
  { value: `${ROLE_ACCOUNT_MANAGER}`, label: 'Account Manager (CSR)' },
  { value: `${ROLE_ACCOUNT_ASSISTANT}`, label: 'Account Assistant (TSR)' },
];

const PROVINCES = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
];

// Province options with integer values for carrier settings (matching backend)
const PROVINCE_OPTIONS = [
  { value: 1, label: 'Ontario' },
  { value: 2, label: 'Alberta' },
  { value: 3, label: 'British Columbia' },
  { value: 4, label: 'Manitoba' },
  { value: 5, label: 'New Brunswick' },
  { value: 6, label: 'Newfoundland and Labrador' },
  { value: 7, label: 'Nova Scotia' },
  { value: 8, label: 'Prince Edward Island' },
  { value: 9, label: 'Quebec' },
  { value: 10, label: 'Saskatchewan' },
  { value: 11, label: 'Northwest Territories' },
  { value: 12, label: 'Nunavut' },
  { value: 13, label: 'Yukon' },
];

const WORKFLOW_TYPE_OPTIONS = [
  { value: `${WORKFLOW_TYPE_ALL}`, label: 'All' },
  { value: `${WORKFLOW_TYPE_AUTO}`, label: 'Auto' },
  { value: `${WORKFLOW_TYPE_HOME}`, label: 'Home' },
  { value: `${WORKFLOW_TYPE_CONDO}`, label: 'Condo' },
  { value: `${WORKFLOW_TYPE_TENANT}`, label: 'Tenant' },
  { value: `${WORKFLOW_TYPE_BUSINESS}`, label: 'Business' },
  { value: `${WORKFLOW_TYPE_LIFE}`, label: 'Life' },
  { value: `${WORKFLOW_TYPE_TRAVEL}`, label: 'Travel' },
  { value: `${WORKFLOW_TYPE_PET}`, label: 'Pet' },
  { value: `${WORKFLOW_TYPE_OTHER}`, label: 'Other' },
];

const LEAD_TYPE_OPTIONS = [
  { value: `${WORKFLOW_TYPE_AUTO}`, label: 'Auto' },
  { value: `${WORKFLOW_TYPE_HOME}`, label: 'Home' },
  { value: `${WORKFLOW_TYPE_CONDO}`, label: 'Condo' },
  { value: `${WORKFLOW_TYPE_TENANT}`, label: 'Tenant' },
  { value: `${WORKFLOW_TYPE_BUSINESS}`, label: 'Business' },
  { value: `${WORKFLOW_TYPE_LIFE}`, label: 'Life' },
  { value: `${WORKFLOW_TYPE_TRAVEL}`, label: 'Travel' },
  { value: `${WORKFLOW_TYPE_OTHER}`, label: 'Other' },
];

export { ROLES_OPTIONS, PROVINCES, PROVINCE_OPTIONS, WORKFLOW_TYPE_OPTIONS, LEAD_TYPE_OPTIONS };
